
import { Component, Inject, DOCUMENT } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'payments-portal-root',
    template: '<router-outlet></router-outlet>',
    styles: [':host { display: flex; flex: 1 1 auto; width: 100%; height: 100%; }'],
    standalone: false
})
export class AppComponent {
    constructor(
        private translate: TranslateService,
        private title: Title,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.translate.onLangChange.subscribe((event) => {
            this.title.setTitle(this.translate.instant('appName'));
            this.document.documentElement.lang = event.lang;
        });
    }
}
